import React, { Component } from 'react';
import { Grid, Button, Typography, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@material-ui/core';
import TextField from '@mui/material/TextField';
import '../CSS/Settings.css';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { deletePrices, getPrices, createPrices, updatePrices, updateVariableRates, getVariableRatesStatus } from '../utils/OpenCampground_Database_Calls'
import { Dialog, DialogContent, DialogTitle, DialogActions } from '@mui/material';
import { withStyles } from '@material-ui/core/styles';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const useStyles = theme => ({
    dialogPaper: {
        padding: theme.spacing(2),
        borderRadius: '10px',
    }
});

const theme = createTheme({
    palette: {
        primary: {
            main: '#2dcd7a',
        },
    },
});

class Prices extends Component {
    constructor(props) {
        super(props);
        this.state = {
            prices: [],
            pricesUpdate: false,
            addNew: false,
            formValid: false,
            editMode: null,
            priceName: '',
            daily: '',
            sunday: '',
            monday: '',
            tuesday: '',
            wednesday: '',
            thursday: '',
            friday: '',
            saturday: '',
            weekly: '',
            monthly: '',
            seasonal: '',
            open: false,
            popupTitle: '',
            popupText: '',
            deleteId: '',
            confirmOpen: false,
            priceId: '',
            confirmPopupTitle: 'Delete Price Class',
            ConfirmPopupText: 'Please make sure that the price class that you are deleting is not associated with any of the current or future reservations.',
            daySpecificRates: false,
            confirmOpen2: false,
            confirmPopupTitle2: 'Update to Day specific Rates',
            ConfirmPopupText2: 'Daily Specific Rate Rates provides a separate rate entry for each day of the week and charges will be computed using the rates for each day. All newly created reservations will inherit this pricing.',
        };
    }

    async componentDidMount() {
        const daySpecificRatesStatus = await getVariableRatesStatus(this.props.user, this.props.serverName)
        this.setState({daySpecificRates:daySpecificRatesStatus})
        this.prices()
    }

    deleteRecord = async (data) => {
        let deleteResponse = await deletePrices(this.props.user, this.props.serverName, data)
        this.setState({
            pricesUpdate: true,
            open: true,
            popupTitle: 'Delete Price Class',
            popupText: 'Price class deleted successfully.'
        })
        this.prices()
    }

    updateVariableRates = async (data) => {
        let deleteResponse = await updateVariableRates(this.props.user, this.props.serverName, data)
    }

    prices = async () => {
        if (this.state.pricesUpdate) {
            let prices = await getPrices(this.props.user, this.props.serverName)
            this.setState({
                prices: prices
            })
        } else {
            if (this.state.prices.length > 0) {
            } else {
                let prices = await getPrices(this.props.user, this.props.serverName)
                this.setState({
                    prices: prices
                })
            }
        }
    }

    handleChange = (event) => {
        this.setState({
            [event.target.id]: event.target.value
        }, () => {
            this.formValidation();
        });
    }

    handleDaySpecificRate = (event) => {
        if(!this.state.daySpecificRates)
            this.setState({ confirmOpen2: true })
        else
        {
            this.updateVariableRates(!this.state.daySpecificRates)
            this.setState({daySpecificRates: !this.state.daySpecificRates})
        }

    }

    formValidation = () => {
        if (this.state.priceName && this.state.daily && this.state.weekly && this.state.monthly && this.state.seasonal) {
            this.setState({
                formValid: true
            });
        } else if (this.state.formValid) {
            this.setState({
                formValid: false
            });
        }
    }

    addNew = async () => {
        await createPrices(this.props.user, this.props.serverName, this.state.priceName, this.state.daily, this.state.weekly, this.state.monthly, this.state.seasonal, this.state.sunday, this.state.monday, this.state.tuesday, this.state.wednesday, this.state.thursday, this.state.friday, this.state.saturday);
        this.setState({
            pricesUpdate: true,
            addNew: false,
            popupTitle: 'New Price Class',
            popupText: 'New price class added successfully.',
            open: true,
            daily: '',
            weekly: '',
            monthly: '',
            seasonal: '',
            sunday: '',
            monday: '',
            tuesday: '',
            wednesday: '',
            thursday: '',
            friday: '',
            saturday: '',
        });
        this.prices();
    }

    handleEdit = (price) => {
        this.setState({
            editMode: price.id,
            priceName: price.price_name,
            daily: price.daily_rate,
            sunday: price.sunday,
            monday: price.monday,
            tuesday: price.tuesday,
            wednesday: price.wednesday,
            thursday: price.thursday,
            friday: price.friday,
            saturday: price.saturday,
            weekly: price.weekly_rate,
            monthly: price.monthly_rate,
            priceId: price.price_id,
            seasonal: price.seasonal_rate
        });
    }

    handleSave = async () => {
        await updatePrices(this.props.user, this.props.serverName, this.state.daily, this.state.weekly, this.state.monthly, 
            this.state.editMode, this.state.priceId, this.state.priceName, this.state.seasonal, this.state.sunday, this.state.monday, this.state.tuesday, this.state.wednesday, this.state.thursday, this.state.friday, this.state.saturday);
        this.setState({
            priceName: '',
            daily: '',
            weekly: '',
            monthly: '',
            seasonal: '',
            sunday: '',
            monday: '',
            tuesday: '',
            wednesday: '',
            thursday: '',
            friday: '',
            saturday: '',
            priceId: '',
            editMode: null,
            pricesUpdate: true,
            open: true,
            popupTitle: 'Edit Price',
            popupText: 'Price updated successfully.'
        });
        this.prices();
    }

    render() {
        const { classes } = this.props;
        return (
            <ThemeProvider theme={theme}>
                <Dialog open={this.state.confirmOpen} onClick={() => this.setState({ confirmOpen: false })} classes={{ paper: classes.dialogPaper }}>
                    <DialogTitle>{this.state.confirmPopupTitle}</DialogTitle>
                    <DialogContent>
                        {this.state.ConfirmPopupText}
                    </DialogContent>
                    <DialogActions style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Button onClick={() => this.setState({ confirmOpen: false })} style={{ backgroundColor: '#FDECEB', color: '#DB3737', padding: '2% 10% 2% 10%', margin: '0 0 0 2%', borderRadius: '10px', marginTop: '3%' }}>
                            Cancel
                        </Button>
                        <Button onClick={() => this.deleteRecord(this.state.deleteId)} style={{ backgroundColor: '#2dcd7a', color: '#000000', padding: '2% 10% 2% 10%', margin: '0 0 0 2%', borderRadius: '10px', marginTop: '3%' }}>
                            Confirm
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={this.state.confirmOpen2} onClick={() => this.setState({ confirmOpen2: false })} classes={{ paper: classes.dialogPaper }}>
                    <DialogTitle>{this.state.confirmPopupTitle2}</DialogTitle>
                    <DialogContent>
                        {this.state.ConfirmPopupText2}
                    </DialogContent>
                    <DialogActions style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Button onClick={() => this.setState({ confirmOpen2: false })} style={{ backgroundColor: '#FDECEB', color: '#DB3737', padding: '2% 10% 2% 10%', margin: '0 0 0 2%', borderRadius: '10px', marginTop: '3%' }}>
                            Cancel
                        </Button>
                        <Button onClick={() => {this.setState({daySpecificRates: !this.state.daySpecificRates});this.updateVariableRates(!this.state.daySpecificRates)}} style={{ backgroundColor: '#2dcd7a', color: '#000000', padding: '2% 10% 2% 10%', margin: '0 0 0 2%', borderRadius: '10px', marginTop: '3%' }}>
                            Confirm
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={this.state.open} onClose={() => this.setState({ open: false })} classes={{ paper: classes.dialogPaper }}>
                    <DialogTitle>{this.state.popupTitle}</DialogTitle>
                    <DialogContent>
                        {this.state.popupText}
                    </DialogContent>
                    <DialogActions style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Button onClick={() => this.setState({ open: false })} style={{ backgroundColor: '#FDECEB', color: '#DB3737', padding: '2% 10% 2% 10%', margin: '0 0 0 2%', borderRadius: '10px', marginTop: '3%' }}>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
                <div style={{display:"flex", width:"95%"}}> 
                <div style={{display:"flex", width:"100%", justifyContent:"flex-end"}}>
                <Button className='resButton' onClick={() => { this.setState({ addNew: true, }) }} style={{ backgroundColor: '#2dcd7a', color: '#000000', marginBottom: '2%', textTransform: "capitalize" }}>Add New Price</Button>
                </div>
                <div style={{display:"flex", width:"100%", justifyContent:"flex-end"}}>
                <FormControlLabel
                label={"Day-Specific Rates"}
                control={
                    <Checkbox
                    id="daySpecificRates"
                    checked={this.state.daySpecificRates}
                    onChange={this.handleDaySpecificRate}
                    />
                    }
                />
                </div>
                </div>

                {this.state.addNew || this.state.editMode
                    ?
                    <Dialog open={this.state.addNew || this.state.editMode} maxWidth="sm" fullWidth
                        onClose={() => { this.setState({ addNew: false, editMode: null, priceName: '', daily: '', weekly: '', monthly: '' }); }} >
                        <DialogContent dividers>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                <h2 style={{ margin: "0px", marginBottom: "10px" }}>{this.state.editMode ? "Update Price" : "Add Price"}</h2>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                    <TextField
                                        id="priceName"
                                        required
                                        label="Price Name"
                                        value={this.state.priceName}
                                        onChange={this.handleChange}
                                    />
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
                                    {!this.state.daySpecificRates?<TextField id="daily" required label="Daily" value={this.state.daily} onChange={this.handleChange} />:
                                    <>
                                    <TextField id="sunday" required label="Sunday" value={this.state.sunday} onChange={this.handleChange} />
                                    <TextField id="monday" required label="Monday" value={this.state.monday} onChange={this.handleChange} />
                                    <TextField id="tuesday" required label="Tuesday" value={this.state.tuesday} onChange={this.handleChange} />
                                    <TextField id="wednesday" required label="Wednesday" value={this.state.wednesday} onChange={this.handleChange} />
                                    <TextField id="thursday" required label="Thursday" value={this.state.thursday} onChange={this.handleChange} />
                                    <TextField id="friday" required label="Friday" value={this.state.friday} onChange={this.handleChange} />
                                    <TextField id="saturday" required label="Saturday" value={this.state.saturday} onChange={this.handleChange} />
                                    </>
                                    }
                                    <TextField id="weekly" required label="Weekly" value={this.state.weekly} onChange={this.handleChange} />
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                    <TextField id="monthly" required label="Monthly" value={this.state.monthly} onChange={this.handleChange} />
                                    <TextField id="seasonal" required label="Seasonal" value={this.state.seasonal} onChange={this.handleChange} />
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '16px' }}>
                                    <Button
                                        style={{ backgroundColor: '#2dcd7a', color: '#000000' }}
                                        onClick={this.state.editMode ? this.handleSave : this.addNew}
                                        disabled={this.state.editMode ? false : !this.state.formValid}
                                    >
                                        {this.state.editMode ? "Update" : "Add"}
                                    </Button>
                                    <Button
                                        style={{ backgroundColor: '#FDECEB', color: '#DB3737' }}
                                        onClick={() => {
                                            this.setState({
                                                addNew: false, editMode: null,
                                                priceName: '',
                                                daily: '',
                                                weekly: '',
                                                monthly: '',
                                            })
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </div>
                        </DialogContent>
                    </Dialog>
                    : ""}

                <TableContainer component={Paper} style={{ width: '95%', margin: '0 auto' }}>
                    <Table className='table'>
                        <TableHead>
                            <TableRow>
                                <TableCell className='tableCell'>Season Name</TableCell>
                                <TableCell className='tableCell'>Price</TableCell>
                                {!this.state.daySpecificRates?<TableCell className='tableCell'>Daily</TableCell>:
                                <><TableCell className='tableCell'>Sun</TableCell>
                                <TableCell className='tableCell'>Mon</TableCell>
                                <TableCell className='tableCell'>Tue</TableCell>
                                <TableCell className='tableCell'>Wed</TableCell>
                                <TableCell className='tableCell'>Thu</TableCell>
                                <TableCell className='tableCell'>Fri</TableCell>
                                <TableCell className='tableCell'>Sat</TableCell>
                                </>}
                                <TableCell className='tableCell'>Weekly</TableCell>
                                <TableCell className='tableCell'>Monthly</TableCell>
                                <TableCell className='tableCell'>Seasonal</TableCell>
                                <TableCell className='tableCell'>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.prices.map((price, index) => (
                                <TableRow key={index}>
                                    <TableCell className='tableCell'>{price.season_name}</TableCell>
                                    <TableCell className='tableCell'>{price.price_name}</TableCell>
                                    {!this.state.daySpecificRates?<TableCell className='tableCell'>{price.daily_rate}</TableCell>:
                                    <>
                                    <TableCell className='tableCell'>{price.sunday}</TableCell>
                                    <TableCell className='tableCell'>{price.monday}</TableCell>
                                    <TableCell className='tableCell'>{price.tuesday}</TableCell>
                                    <TableCell className='tableCell'>{price.wednesday}</TableCell>
                                    <TableCell className='tableCell'>{price.thursday}</TableCell>
                                    <TableCell className='tableCell'>{price.friday}</TableCell>
                                    <TableCell className='tableCell'>{price.saturday}</TableCell>
                                    </>
                                    }
                                    <TableCell className='tableCell'>{price.weekly_rate}</TableCell>
                                    <TableCell className='tableCell'>{price.monthly_rate}</TableCell>
                                    <TableCell className='tableCell'>{price.seasonal_rate}</TableCell>
                                    {/* <TableCell className='tableCell'>{price.active}</TableCell> */}
                                    <TableCell className='tableCell'>
                                        <div>
                                            <Button
                                                className='viewButtons'
                                                onClick={() => this.handleEdit(price)}
                                                style={{ backgroundColor: '#d4d4d4', color: 'black' }}
                                            >
                                                Edit
                                            </Button>
                                            <Button className='viewButtons' onClick={() => this.setState({ deleteId: price.price_id, confirmOpen: true })}>
                                                Delete
                                            </Button>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </ThemeProvider>
        );
    };
};
export default withStyles(useStyles)(Prices);